import type { IconData } from '@/frontend-types'
import { cx } from 'cva'
import Image from 'next/image'
import type { FC, PropsWithChildren } from 'react'
import { PlaceholderImage } from '../atoms/PlaceholderImage'
import ContentBlockWrapper from '../molecules/ContentBlockWrapper'

export type IconCopyBlockProps = {
	iconImage?: IconData
	layout: 'default' | 'reverse'
}

export const IconCopyBlock: FC<PropsWithChildren<IconCopyBlockProps>> = ({
	iconImage,
	layout,
	children,
}) => {
	const layoutLeft =
		layout === 'default' ? 'layout-wide:tablet-l:col-start-1' : 'layout-wide:tablet-l:col-start-9'
	const layoutRight =
		layout === 'default' ? 'layout-wide:tablet-l:col-start-5' : 'layout-wide:tablet-l:col-start-1'

	return (
		<ContentBlockWrapper
			blockTypes={['header', 'component', 'cta']}
			gridClassName="gap-y-xl"
			layout="nested"
		>
			<div
				className={cx(
					'col-span-full pb-xl tablet-l:pb-0 layout-wide:tablet-l:col-span-4 layout-wide:tablet-l:row-start-1',
					layoutLeft,
					'row-start-1',
				)}
			>
				<div className="flex w-full items-start justify-start pt-xl layout-wide:tablet-l:justify-center">
					<div className="relative aspect-square h-auto w-32 desktop:w-60 layout-wide:tablet-l:w-50">
						{iconImage ? (
							<Image
								src={iconImage.src}
								alt=""
								fill
								className="object-cover"
								sizes="(max-width:767px) 30.47vw, (max-width: 1023px) 16.64vw, (max-width: 1279px) 19.53vw, (max-width: 1559px) 240px, 360px"
							/>
						) : (
							<PlaceholderImage />
						)}
					</div>
				</div>
			</div>
			<div
				className={cx(
					'col-span-full layout-wide:tablet-l:col-span-8 layout-wide:tablet-l:row-start-1',
					layoutRight,
					'row-start-2',
				)}
			>
				{children}
			</div>
		</ContentBlockWrapper>
	)
}
